export const SINGPASS_CONFIG = {
  dxpWidgetUrl:
    process.env.REACT_APP_DXP_WIDGETS_BASE_PATH +
    `${process.env.REACT_APP_COUNTRY}/${process.env.REACT_APP_BRAND_CODE}/widgets/singpass/dist/singpass.esm.js`,
};
